/** Global preferences group native variants; node Config keeps the exact model. */
import { VIDEO_FAMILIES } from '../../generated/videoModelFamilies'
import type { ByomModelInfo } from '../../api/client'
import { getVideoModelDisplayName } from './nodes/shared/videoModelDisplayName'
import { getNativeVideoAspectRatios } from './nodes/shared/videoConstraints'

export function videoFamilyFor(id: string) {
  return VIDEO_FAMILIES.find(family => family.id === id || family.models.includes(id) || (id === 'veo-3.1' && family.id === 'video-family/veo-3.1'))
}

export function videoPreferenceId(id: string): string {
  return videoFamilyFor(id)?.id ?? id
}

export function normalizeVideoPreferences(ids: readonly string[]): string[] {
  return [...new Set(ids.map(videoPreferenceId))]
}

export function videoPreferenceLabel(id: string, byom: ByomModelInfo[]): string {
  return videoFamilyFor(id)?.label ?? getVideoModelDisplayName(id, byom)
}

export function videoPreferenceAspectRatios(id: string, native: readonly string[]): string[] {
  const family = videoFamilyFor(id)
  if (!family) return getNativeVideoAspectRatios(id)
  return [...new Set(native.filter(model => videoFamilyFor(model)?.id === family.id).flatMap(getNativeVideoAspectRatios))]
}
